module.exports = __webpack_public_path__ + "static/media/nadjaAlexander.57ef45ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/authorSpotlight/nadjaAlexander.jpg
// module id = 1273
// module chunks = 1